import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { maybeDisableAnimations, isMobileDevice } from './utils/mobileUtils'

// Глобально отключаем анимации на мобильных устройствах
maybeDisableAnimations();

// Force scroll to top on page load
window.addEventListener('load', () => {
  window.scrollTo({ top: 0, behavior: 'instant' });
  
  // Дополнительная проверка и отключение анимаций после загрузки
  if (isMobileDevice()) {
    document.body.classList.add('mobile-no-animations');
  }
});

// Prevent browser from restoring scroll position
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

// Register service worker for PWA functionality (optional)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)